import { render, staticRenderFns } from "./CatalogProductsList.vue?vue&type=template&id=43564b1c&scoped=true"
import script from "./CatalogProductsList.vue?vue&type=script&lang=ts"
export * from "./CatalogProductsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43564b1c",
  null
  
)

export default component.exports